import axios from 'axios';

import { config } from '@config/env';
import type { ApiResponse } from '@/types/api';
import type { BrowserSessionResponse } from '@/types/auth';

const MS_PER_SECOND = 1000;
const BROWSER_SESSION_REQUEST_TIMEOUT_MS = 30 * MS_PER_SECOND;

/** Browser cookie calls must not enter the general client's 401 refresh handler. */
export const browserSessionClient = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: BROWSER_SESSION_REQUEST_TIMEOUT_MS,
});

export const unwrapBrowserSession = (
  response: BrowserSessionResponse | ApiResponse<BrowserSessionResponse>,
): BrowserSessionResponse => {
  if ('data' in response) {
    if (!response.data) {
      throw new Error('browser_session_response_missing_data');
    }
    return response.data;
  }
  return response;
};
